/**
 * Small bent-arrow glyph used to prefix a per-evidence correction line.
 * @module correction-arrow-icon
 */

/** Props for {@link CorrectionArrowIcon}. */
interface CorrectionArrowIconProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  /** Stroke color; defaults to the muted grey used in the feedback summary. */
  color?: string;
}

/**
 * Renders the correction arrow icon.
 *
 * @param props - Optional sizing, className, and stroke color overrides
 * @returns The rendered SVG icon
 */
export function CorrectionArrowIcon({
  className,
  width = "14",
  height = "14",
  color = "#6B6B6B",
}: CorrectionArrowIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M3 3V7C3 7.53043 3.21071 8.03914 3.58579 8.41421C3.96086 8.78929 4.46957 9 5 9H11M9 11L11 9L9 7"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
